import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { TradeHeader } from "../../molecules/SubHeader";
import { CreateOrderModal } from "./CreateOrderModal";
import { useGetOrdersForCompany } from "@/services/Orders";
import MarketList from "./MarketLists";
import ActiveOrders from "./ActiveOrders";

const Market = () => {
  const { currentCompany, user } = useAuth();
  const navigate = useNavigate();

  const [isCreateOrderOpen, setIsCreateOrderOpen] = useState<boolean>(false);
  const [activeOrderPageNumber, setActiveOrderPageNumber] = useState(1);
  const [activeOrderLimit, setActiveOrderLimit] = useState(15);

  const { data: ordersData, isLoading: isLoadingOrderData } = useGetOrdersForCompany({
    companyId: currentCompany?.companyId as number,
    languageId: user?.language.id,
    includeInactive: false,
    pageNumber: activeOrderPageNumber,
    excludeContractOrders: true,
    limit: activeOrderLimit,
  });
  const orders = ordersData?.orders || [];
  const totalActiveOrders = (ordersData?.numberOfPages ?? 0) * activeOrderLimit;

  return (
    <>
      <title>Reviver - Market</title>
      <meta name="description" content="Reviver - Market" />

      <TradeHeader
        createNew={() => setIsCreateOrderOpen(true)}
        orders={orders}
        companyName={currentCompany?.companyName ?? ""}
      />

      <CreateOrderModal isOpen={isCreateOrderOpen} onClose={() => setIsCreateOrderOpen(false)} onSubmit={(_) => {}} />

      <ActiveOrders
        createNew={() => setIsCreateOrderOpen(true)}
        handleActiveOrder={(order) => navigate(`/order/details/${order.id}`)}
        orders={orders}
        isLoadingOrders={isLoadingOrderData}
        pageNumber={activeOrderPageNumber}
        limit={activeOrderLimit}
        totalOrders={totalActiveOrders}
        onPageChange={setActiveOrderPageNumber}
        onRowsPerPageChange={(value) => {
          setActiveOrderLimit(value);
          setActiveOrderPageNumber(1);
        }}
      />

      <MarketList onCreateOrder={() => setIsCreateOrderOpen(true)} />
    </>
  );
};

export default Market;
